<template>
  <transition name="fade">
    <div class="uid-guide-popup" v-if="visible">
      <em class="uid-guide-mask" @click="hidePopup"></em>
      <div class="uid-guide-box">
        <div class="uid-guide-box-title">
          {{
            isRoleIdLogin
              ? 'キャラクターIDでログイン'
              : 'ユーザーIDのご案内いたします。'
          }}
        </div>
        <div class="uid-guide-box-detail" v-if="isRoleIdLogin">
          <div class="img-wrap">
            <img :src="roleIdGuideImg" class="img img1" alt="" />
          </div>
        </div>
        <div class="uid-guide-box-detail" v-else>
          <p class="step">1. 府内にあるユーザーセンターをタップして、</p>
          <div class="img-wrap">
            <img :src="inGameGuideImg1" class="img img1" alt="" />
          </div>
          <p class="step">
            2.「左上に表示させてあるID番号」を確認、お願いいたします
          </p>
          <div class="img-wrap">
            <img :src="inGameGuideImg2" class="img img2" alt="" />
          </div>
        </div>
        <a
          class="uid-guide-popup-close click-uid-guide-close"
          @click="hidePopup"
        ></a>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'BeautyUidGuidePopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isRoleIdLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId
    }),
    inGameGuideImg1() {
      return require(`@assets/image/officialTopup/beauty/uid-guide-img-1.jpeg`);
    },
    inGameGuideImg2() {
      return require(`@assets/image/officialTopup/beauty/uid-guide-img-2.jpeg`);
    },
    roleIdGuideImg() {
      return require(`@assets/image/officialTopup/beauty/roleIdGuide.png`);
    }
  },
  methods: {
    hidePopup() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/officialTopup.scss';
.uid-guide-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  .uid-guide-mask {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
  }
  .uid-guide-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    background: #fff;
    width: 632px !important;
    height: 759px !important;
    &-title {
      margin: 82px auto 42px;
      text-align: center;
      font-weight: bold;
      font-size: 34px;
    }
    &-detail {
      overflow-x: hidden;
      overflow-y: scroll;
      padding: 0 45px;
      height: 582px;
      .step {
        text-align: left;
        font-weight: bold;
        font-size: 28px;
      }
      .step-order {
        font-weight: bold;
        font-size: 36px;
      }
      .img-wrap {
        margin-top: 12px;
        margin-bottom: 38px;
        padding: 20px;
        background: rgba(0, 0, 0, 0.4);
        .img {
          margin: 0 auto;
          max-width: 100%;
          background-size: cover;
        }
      }
    }
  }
  &-close {
    position: absolute;
    right: 32px;
    top: 27px;
    background: url($commonImg + 'close.png') no-repeat;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }
}
@media screen and (orientation: landscape) {
  .uid-guide-popup {
    .uid-guide-box {
      position: absolute;
      width: 545px !important;
      height: 654px !important;
      &-title {
        margin-top: 58px;
        margin-bottom: 34px;
        font-size: 30px;
      }
      &-detail {
        overflow: -moz-scrollbars-none;
        padding: 0 28px;
        height: 516px;

        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
          width: 0 !important;
        }
        .step {
          font-size: 18px;
        }
        .step-order {
          font-size: 24px;
        }
        .img-wrap {
          margin-bottom: 35px;
        }
      }
    }
    &-close {
      position: absolute;
      right: 15px;
      top: 19px;
      background: url($commonImg + 'close.png') no-repeat;
      width: 23px;
      height: 23px;
      cursor: pointer;
      background-size: cover;
    }
  }
}
</style>
